import axios from 'axios'
import notifService from '../../services/notifService'

export const getProspekBank = async ({ commit }, pagination) => {
  let res = await axios
    .get('/cms/prospek-banks', {
      params: pagination
    })
    .then(response => {
      commit('getProspekBank', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const addProspekBank = async (_context, data) => {
  let res = await axios
    .post('/cms/prospek-banks/add', data, {
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(response => {
      // commit('getProspekBank', response.data.data)
      notifService.notif('apiRes', response.data.message, 'success')

      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const editProspekBank = async ({ commit }, data) => {
  let res = await axios
    .put('/cms/prospek-banks/edit/' + data.id, data, {
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(response => {
      commit('prospekDetail', response.data.data)
      notifService.notif('apiRes', response.data.message, 'success')
      return 'success'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const prospekExcel = async (_context, pagination) => {
  let res = await axios
    .get('/cms/prospek-banks/report/excel', {
      params: pagination,
      responseType: 'blob'
    })
    .then(response => {
      let date_start = pagination.start_date ? '_' + pagination.start_date : ''
      let date_end = pagination.end_date ? '_' + pagination.end_date : ''

      let fileTitle = 'Prospek_Bank' + date_start + date_end + '.xlsx'

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileTitle)
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const prospekExcelV2 = async (_context, pagination) => {
  let res = await axios
    .get('/cms/prospek-banks/report/excel-v2', {
      params: pagination,
      responseType: 'blob'
    })
    .then(response => {
      let date_start = pagination.start_date ? '_' + pagination.start_date : ''
      let date_end = pagination.end_date ? '_' + pagination.end_date : ''

      let fileTitle = 'Prospek_Bank' + date_start + date_end + '.xlsx'

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileTitle)
      document.body.appendChild(link)
      link.click()
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const prospekDetail = async (context, id) => {
  await axios
    .get('/cms/prospek-banks/detail/' + id)
    .then(response => {
      context.commit('prospekDetail', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const deleteProspekBank = async (context, val) => {
  let res = await axios
    .delete('/cms/prospek-banks/delete/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const removeProspek = async (context, val) => {
  let res = await axios
    .delete('/cms/prospek-banks/remove/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const formProspekBank = async (context, data) => {
  context.commit('formProspekBank', data)
}

export const getProbability = async (context, pagination) => {
  await axios
    .get('/cms/prospek-banks/probability', {
      params: pagination
    })
    .then(response => {
      context.commit('getProbability', response.data.data)
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })
}

export const getProbabilityActivity = async (context, pagination) => {
  return await axios
    .get('/cms/prospek-banks/probability/activity', {
      params: pagination
    })
    .then(response => {
      context.commit('getProbabilityActivity', response.data.data)
      return response.data.data
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })
}

export const approveProspek = async (context, data) => {
  let res = await axios
    .put('/cms/prospek-banks/approval/' + data.id, data, {
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'success'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const updateProbability = async (_context, data) => {
  let res = await axios
    .post('/cms/prospek-banks/probability/update', data, {
      headers: {
        'content-type': 'application/json'
      }
    })
    .then(response => {
      // commit('getProspekBank', response.data.data)
      notifService.notif('apiRes', response.data.message, 'success')

      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return 'error'
    })

  return res
}

export const voidRequest = async (context, val) => {
  let res = await axios
    .get('/cms/prospek-banks/void/' + val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return 'ok'
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
    })

  return res
}

export const getPBStatus = async (context, pagination) => {
  return await axios
    .get('/cms/prospek-banks/status', {
      params: pagination
    })
    .then(response => {
      context.commit('getPBStatus', response.data.data)

      return response.data.meta
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const addPBStatus = async (context, val) => {
  return await axios
    .post('/cms/prospek-banks/status/add', val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const editPBStatus = async (context, val) => {
  return await axios
    .put('/cms/prospek-banks/status/edit/' + val.id, val)
    .then(response => {
      notifService.notif('apiRes', response.data.message, 'success')
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')
      return false
    })
}

export const deletePBStatus = async (context, val) => {
  return await axios
    .delete('/cms/prospek-banks/status/delete/' + val)
    .then(response => {
      return true
    })
    .catch(error => {
      if (error.response) notifService.notif('apiRes', error.response.data.message, 'error')

      return false
    })
}

export const pbStatusForm = (context, val) => {
  context.commit('pbStatusForm', val)
}

export const pbTableSort = (context, val) => {
  context.commit('pbTableSort', val)
}

export const getNotifApproval = async ({ commit }) => {
  let res = await axios
    .get('/cms/notif-approval')
    .then(response => {
      commit('getNotifApproval', response.data.data)
      return response.data.meta
    })
    .catch(error => {
      if (error.response) {
        notifService.notif('apiRes', error.response.data.message, 'error')
      }
      return false
    })

  return res
}
